import { Component, Inject, Type } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BaseModalComponent } from './base-modal.component';
import { ModuleHelpVideoModalComponent } from './module-help-video-modal.component';
import { NgComponentOutlet, NgIf } from '@angular/common';

export interface ModuleSpecificHelpData {
  contentComponent?: Type<unknown>;
  showBasicVideoHelpComponent: boolean;
  videoTutorialUrl: string;
}

@Component({
  selector: 'hk-module-specific-help',
  template: `
    <hk-base-modal [hideCancelButton]="true" [hideApplyButton]="true" [title]="'moduleHelp.title' | translate">
      <ng-container *ngIf="data.showBasicVideoHelpComponent && data.videoTutorialUrl">
        <hk-module-help-video-modal [videoUrlString]="data.videoTutorialUrl"></hk-module-help-video-modal>
      </ng-container>
      <ng-container *ngIf="!data.showBasicVideoHelpComponent && data.contentComponent">
        <ng-container *ngComponentOutlet="data.contentComponent"></ng-container>
      </ng-container>
    </hk-base-modal>
  `,
  standalone: true,
  host: { class: 'flex flex-1 flex-col' },
  imports: [BaseModalComponent, ModuleHelpVideoModalComponent, TranslateModule, NgIf, NgComponentOutlet],
})
export class ModuleSpecificHelpModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModuleSpecificHelpData,
    public dialog: MatDialog,
    public translate: TranslateService,
  ) {}
}
